<template>
  <el-menu
    :default-active="index"
    collapse
    @select="$emit('update:active', $event)"
  >
    <template v-if="state !== 'stopped'">
      <el-menu-item index="general">
        <el-badge v-if="tasks.length > 0" :value="tasks.length">
          <img :src="bundleImage(bundleId)" />
        </el-badge>
        <img v-else :src="bundleImage(bundleId)" />
      </el-menu-item>

      <el-menu-item index="domain">
        <i class="mdi mdi-web" />
      </el-menu-item>

      <el-menu-item index="settings">
        <i class="mdi mdi-cog-outline" />
      </el-menu-item>

      <!--
      <el-menu-item index="builds">
        <i class="mdi mdi-source-fork" />
      </el-menu-item>
      -->

      <el-menu-item index="sftp">
        <i class="mdi mdi-upload-lock" />
      </el-menu-item>

      <el-menu-item index="logs">
        <i class="mdi mdi-text-box-search" />
      </el-menu-item>

      <el-menu-item index="redirection">
        <i class="mdi mdi-directions-fork" />
      </el-menu-item>

      <el-menu-item index="backups" v-bind:class="{ danger: backup !== '1' }">
        <i class="mdi mdi-backup-restore" />
      </el-menu-item>
    </template>

    <el-menu-item index="destroy">
      <i class="mdi mdi-delete-circle" />
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  props: {
    bundleId: String,
    backup: String,
    active: String,
    state: String,
    tasks: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      index: this.active
    }
  },
  mounted () {
    console.log(this.tasks)
  },
  watch: {
    active (value) {
      this.index = value
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .el-menu--collapse {
    width: 48px;
    height: 100%;
    border-color: $--border-color-base;
  }
  .el-menu-item {
    .mdi, img {
      margin: 0;
      vertical-align: middle;
      width: 24px;
      font-size: 24px;
      text-align: center;
    }

    &:focus, &:hover {
      background-color: $--background-color-base;
    }
    &.danger .mdi {
      color: $--color-danger;
    }
  }
</style>
